// File modified from https://github.com/udecode/plate/blob/main/packages/resizable/src/components/useResizableStore.ts
import { createAtomStore } from 'lib-knowledge-document-structure/plate/common';
import type React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const { ResizableProvider, resizableStore, useResizableStore }: any =
  createAtomStore(
    {
      height: 0 as React.CSSProperties['height'],
    },
    { name: 'resizable' },
  );
